import React from 'react';
import { TextField, Autocomplete, Tooltip, InputAdornment, IconButton, CircularProgress } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import { CepMaskCustom } from '../form/MaskedInputs';

export default function CompanyStep2Address({
  formData,
  handleInputChange,
  cities,
  loadingCities,
  handleAddressAutocompleteChange,
  countries,
  errors = {} // Define um valor padrão para a prop errors
}) {
  return (
    <div className="form-grid" style={{ gridTemplateColumns: '1fr 1fr', gap: 'var(--space-4)' }}>
      <h4 className="form-section-title" style={{ gridColumn: '1 / -1' }}>Endereço</h4>
      <TextField 
        label="CEP" 
        name="postalCode" 
        value={formData.postalCode || ''} 
        onChange={handleInputChange} 
        onBlur={(e) => {
          const cleanCep = e.target.value.replace(/\D/g, '');
          if (cleanCep.length === 8) {
            // Chama a função de busca de CEP apenas quando o usuário sai do campo e o CEP está completo
            const fetchAddressByCep = async (cep) => {
              const cleanCep = cep.replace(/\D/g, '');
              if (cleanCep.length !== 8) return;

              try {
                const response = await fetch(`https://viacep.com.br/ws/${cleanCep}/json/`);
                const data = await response.json();

                if (data.erro) {
                  // Pode adicionar erro se necessário
                } else {
                  // Atualiza os campos de endereço
                  handleInputChange({ target: { name: 'address', value: data.logradouro } });
                  handleInputChange({ target: { name: 'district', value: data.bairro } });
                  handleInputChange({ target: { name: 'city', value: data.localidade } });
                  handleInputChange({ target: { name: 'state', value: data.uf } });
                }
              } catch (error) {
                console.error('Erro ao buscar CEP:', error);
              }
            };
            fetchAddressByCep(e.target.value);
          }
        }}
        fullWidth 
        InputProps={{ inputComponent: CepMaskCustom }}
        error={!!errors?.postalCode}
        helperText={errors.postalCode}
      />
      <TextField 
        label="Rua"
        name="address" value={formData.address || ''} onChange={handleInputChange} fullWidth 
      />
      <TextField label="Número" name="number" value={formData.number || ''} onChange={handleInputChange} fullWidth />
      <TextField label="Complemento" name="complement" value={formData.complement || ''} onChange={handleInputChange} fullWidth />
      <TextField label="Bairro" name="district" value={formData.district || ''} onChange={handleInputChange} fullWidth />
      <Autocomplete
        options={cities}
        getOptionLabel={(option) => option.nome || ''}
        value={cities.find(c => c.nome === formData.city) || null}
        onChange={(event, newValue) => handleAddressAutocompleteChange('city', newValue)}
        isOptionEqualToValue={(option, value) => option.nome === value.nome}
        disabled={!formData.state || loadingCities}
        renderInput={(params) => (
          <TextField
            {...params}
            label="Cidade"
            placeholder={loadingCities ? 'Carregando...' : 'Selecione a cidade'}
            InputProps={{
              ...params.InputProps,
              endAdornment: <>{loadingCities ? <CircularProgress color="inherit" size={20} /> : null}{params.InputProps.endAdornment}</>,
            }}
          />
        )} />
      <TextField
        label="Estado (UF)"
        name="state"
        value={formData.state || ''}
        disabled
        fullWidth
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <Tooltip title="O estado é preenchido automaticamente pela busca de CEP ou sincronizado com os 'Dados da Empresa'. Para alterar, modifique o CEP ou o campo de estado na primeira etapa.">
                <IconButton tabIndex={-1} type="button"><InfoIcon fontSize="small" /></IconButton>
              </Tooltip>
            </InputAdornment>
          ),
        }} />
      <Autocomplete
        options={countries}
        getOptionLabel={(option) => option.name || ''}
        value={countries.find(c => c.name === formData.country) || null}
        onChange={(event, newValue) => handleAddressAutocompleteChange('country', newValue)}
        isOptionEqualToValue={(option, value) => option.code === value.code}
        renderInput={(params) => <TextField {...params} label="País" />}
      />
    </div>
  );
}